import { Button, ButtonGroup } from '@mui/material/';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import allActions from '../../actions/product_builder';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
const SideButtonGroup = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const sideOptions = useSelector((state) => state.rootReducer.settingsOptions.options);
    const currentCategory = useSelector(
        (state) => state.rootReducer.currentCategory.activeCategory
    );
    useEffect(() => {
        if (currentCategory === 'Cable') {
            dispatch(allActions.settingsActions.setCurrentSide('both'));
            setSide('both');
        }
    }, [currentCategory]);
    const [currSide, setSide] = useState('both');
    const configure = (option) => {
        dispatch(allActions.settingsActions.setCurrentSide(option));
        setSide(option);
    };

    let sideOptionPicker = sideOptions.map((option) => {
        const side = `btnPill${option}`;
        let activeStyle = `${buttons.btnPillActive} ${buttons[side]}`;
        let inactiveStyle = `${buttons.btnPill} ${buttons[side]}`;
        if (currentCategory === 'Cable' && option !== 'both') {
            inactiveStyle += ` ${buttons.btnPillDisabled}`;
        }
        return (
            <Button
                disabled={currentCategory === 'Cable' && option !== 'both'}
                key={option}
                className={currSide === option ? activeStyle : inactiveStyle}
                option={option}
                onClick={() => {
                    configure(option);
                }}
                onTouchStart={() => {
                    configure(option);
                }}>
                {t(`settings.${option}_button`)}
            </Button>
        );
    });

    return <ButtonGroup className={layout.flexItem}>{sideOptionPicker}</ButtonGroup>;
};

export default SideButtonGroup;
